/* Little Lili store upgrade (Claude Cowork, 24 Sep 2026; basket v2 and v4 the same day).
   1. Dispatch countdown: under Add to basket and in the basket drawer (under the items).
      Rule (from the product page delivery panel): orders before 11am UK time, Monday to Friday,
      are dispatched the same working day; otherwise the next working day. Hidden while the
      away notice (#aovx-away) is active. No arrival-date promise.
   2. Basket drawer "Picked for {name}" (v4, 24 Sep): a swipe row of up to 9 cards for the basket item: a smart set
      of DIFFERENT designs that match it (theme words, same birthday age, garments mixed, sizes that fit the child,
      girl/boy respected), 1-2 upcoming-event pieces (Halloween, Christmas, ...), family pieces, and "For a sibling"
      (the same item with another name) last. No "Same design" cards (Patryk, 24 Sep). Size preselected, name
      prefilled. Data: sections/lili-drawer-set.liquid and sections/lili-drawer-similar.liquid. The sticky footer is one row (subtotal + checkout); the dispatch line,
      delivery note and "View full basket" scroll with the items.
   3. Product reviews: when a product has no reviews yet, show the shop's featured reviews instead
      of an empty "Be the first" box (the write-a-review button stays).
   Fails quietly: if anything is missing, the page works exactly as before. */
(function () {
  'use strict';
  var TZ = 'Europe/London';
  var CUTOFF_HOUR = 11;
  // England and Wales bank holidays (gov.uk), treated as non-dispatch days.
  var HOLIDAYS = ['2026-12-25', '2026-12-28', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03',
    '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'];
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function ukParts(date) {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23', weekday: 'short' });
    var o = {};
    f.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
    var wd = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(o.weekday);
    return { ymd: o.year + '-' + o.month + '-' + o.day, h: parseInt(o.hour, 10), m: parseInt(o.minute, 10), wd: wd };
  }
  function isWorkday(p) { return p.wd >= 1 && p.wd <= 5 && HOLIDAYS.indexOf(p.ymd) < 0; }
  function awayActive() {
    var a = document.getElementById('aovx-away');
    if (!a) return false;
    var now = ukParts(new Date());
    var stamp = now.ymd + 'T' + String(now.h).padStart(2, '0') + ':' + String(now.m).padStart(2, '0');
    var s = a.getAttribute('data-start') || '', e = a.getAttribute('data-end') || '';
    return (!s || stamp >= s) && (!e || stamp < e);
  }
  function dispatchText() {
    if (awayActive()) return '';
    var now = new Date(), p = ukParts(now);
    if (isWorkday(p) && p.h < CUTOFF_HOUR) {
      var mins = (CUTOFF_HOUR - p.h) * 60 - p.m;
      var h = Math.floor(mins / 60), m = mins % 60;
      var left = (h > 0 ? h + 'h ' : '') + m + 'm';
      return 'Order in the next <strong>' + left + '</strong> and we send it <strong>today</strong>';
    }
    for (var i = 1; i <= 10; i++) {
      var d = new Date(now.getTime() + i * 86400000), q = ukParts(d);
      if (isWorkday(q)) {
        var when = i === 1 ? 'tomorrow' : 'on ' + DAYS[q.wd];
        return 'Order now and we send it <strong>' + when + '</strong>';
      }
    }
    return '';
  }
  var VAN = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
  function paintDispatch() {
    var html = dispatchText();
    var empty = !!document.querySelector('#aovxd-root [data-aovxd-items] .aovxd-empty');
    document.querySelectorAll('[data-lili-dispatch]').forEach(function (el) {
      if (!html || (empty && el.classList.contains('lili-dispatch--drawer'))) { el.hidden = true; return; }
      el.innerHTML = VAN + '<span>' + html + '</span>';
      el.hidden = false;
    });
  }
  function mountDispatch() {
    // Product page: right under the add-to-basket buttons.
    var buttons = document.querySelector('.product__section--buttons');
    if (buttons && !document.querySelector('.lili-dispatch--pdp')) {
      var line = document.createElement('p');
      line.className = 'lili-dispatch lili-dispatch--pdp';
      line.setAttribute('data-lili-dispatch', '');
      line.hidden = true;
      buttons.insertAdjacentElement('afterend', line);
    }
    // Basket drawer: right under the items, inside the part that scrolls (not the sticky footer).
    var its = document.querySelector('#aovxd-root .lili-dscroll > [data-aovxd-items]');
    if (its && !document.querySelector('#aovxd-root .lili-dispatch--drawer')) {
      var dl = document.createElement('p');
      dl.className = 'lili-dispatch lili-dispatch--drawer';
      dl.setAttribute('data-lili-dispatch', '');
      dl.hidden = true;
      its.insertAdjacentElement('afterend', dl);
    }
    paintDispatch();
  }

  /* ---------- Basket drawer: Picked for {name} (v4) ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '£' + (c / 100).toFixed(2); }
  var root = null, block = null, timer = null, lastKey = '', busy = false, cache = {};
  var MAX_CARDS = 9, MAX_SIMILAR = 6;
  // Theme words used to say why a design matches ("Rabbit design"); the first shared one in the basket title wins.
  var THEMES = ('rabbit bunny pumpkin dinosaur dino digger excavator construction tractor farm truck unicorn princess castle mermaid fairy ' +
    'butterfly ballerina rainbow car racing train aeroplane plane rocket space football bear teddy safari lion tiger elephant giraffe ' +
    'panda monkey owl fox woodland deer cat dog puppy strawberry bee whale shark ocean reindeer santa elf snowman ghost witch boo ' +
    'mummy daddy nanny grandma grandad auntie uncle heart floral flower star').split(' ');
  // Words that say nothing about the design; similar designs must share at least one real theme word.
  var STOP = ('personalised personalized name names kid kids child children childrens toddler toddlers baby babies girl girls boy boys ' +
    'for with and the a an of my our your in to on at by from this that will when wake up be t-shirt tshirt tee shirt sweatshirt ' +
    'jumper pyjama pyjamas pjs set bodysuit vest gift idea birthday happy 1st 2nd 3rd 4th 5th 6th 7th first second third one two ' +
    'three four five six seven age year initial letter script lettering cute little big lil style new time short long sleeve').split(' ');
  var SOFT = 'halloween christmas easter valentine watercolour pastel pink blue green red yellow purple lilac rainbow heart floral flower star'.split(' ');
  var ROLE_RE = /\b(big|little|lil)\s+(sister|brother|cousin|sis|bro)\b|promoted to|going to be/i;
  var GARMENT_RE = /\b(t-?shirts?|tees?|sweatshirts?|jumpers?|hoodies?|bodysuits?|vests?|pyjamas?|pjs|sets?)\b/g;
  // Upcoming events: shown from `from` to `to` (MM-DD, UK date). Movable dates per year in `dates`.
  var EVENTS = [
    { tag: 'Halloween · 31 Oct', handle: 'fall-halloween', from: '09-01', to: '10-27', words: ['halloween', 'pumpkin', 'trick or treat', 'spooky'] },
    { tag: 'Christmas · 25 Dec', handle: 'christmas', from: '10-01', to: '12-18', words: ['christmas', 'xmas', 'santa', 'reindeer', 'nice list', 'festive'] },
    { tag: 'Valentine’s · 14 Feb', handle: 'valentines-collection', from: '01-10', to: '02-11', words: ['valentine'] },
    { tag: 'Mother’s Day', handle: 'mothers-day-all', dates: { '2027': ['02-01', '03-04', '7 Mar'], '2028': ['02-20', '03-23', '26 Mar'] }, words: ['mother\'s day', 'mothers day', 'mother’s day'] },
    { tag: 'Easter', handle: 'easter', dates: { '2027': ['03-01', '03-24', '28 Mar'], '2028': ['03-15', '04-12', '16 Apr'] }, words: ['easter'] },
    { tag: 'Father’s Day', handle: 'all-fathers-day', dates: { '2027': ['05-20', '06-17', '20 Jun'], '2028': ['05-18', '06-15', '18 Jun'] }, words: ['father\'s day', 'fathers day', 'father’s day'] },
    { tag: 'Nursery graduation', handle: 'graduation-collection', from: '06-01', to: '07-20', words: ['graduat'] },
    { tag: 'Summer holidays', handle: 'summer-collection', from: '05-15', to: '08-10', words: ['holiday', 'travel', 'flyer', 'summer', 'beach', 'aeroplane'] },
    { tag: 'Back to nursery', handle: 'nursery-school', from: '08-01', to: '09-15', words: ['nursery', 'school', 'preschool'] }
  ];
  function words(t) {
    var o = {};
    String(t || '').toLowerCase().replace(/[^a-z0-9\- ]+/g, ' ').split(/\s+/).forEach(function (w) {
      w = w.replace(/^-+|-+$/g, '');
      if (w.length > 4 && /s$/.test(w) && !/(ss|us|mas)$/.test(w)) w = w.slice(0, -1);
      if (w.length < 3 || STOP.indexOf(w) >= 0) return;
      if (!o[w]) o[w] = SOFT.indexOf(w) >= 0 ? 1 : 2;
    });
    return o;
  }
  var AGE_WORDS = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
  // Birthday age in a title ("4th Birthday", "I'm 4", "Will Be Four"); 0 when there is none.
  function ageOf(t) {
    t = String(t || '').toLowerCase();
    var m = t.match(/\b(\d{1,2})(?:st|nd|rd|th)\b/) || t.match(/\b(?:i'?m|i am|will be|turning)\s+(\d{1,2})\b/);
    if (m) return parseInt(m[1], 10);
    m = t.match(/\b(?:i'?m|i am|will be|turning|number)\s+(one|two|three|four|five|six|seven|eight|nine|ten)\b/);
    return m ? AGE_WORDS.indexOf(m[1]) : 0;
  }
  function genderOf(t) { t = String(t || '').toLowerCase(); var g = /\bgirls?\b/.test(t), b = /\bboys?\b/.test(t); return g && !b ? 'g' : b && !g ? 'b' : ''; }
  // Size range in months from a variant title: "6-12 Months" -> [6, 12], "2-3 Years" -> [24, 36], "Newborn" -> [0, 1].
  function sizeRange(t) {
    t = String(t || '').toLowerCase();
    if (/newborn|tiny baby|early baby/.test(t)) return [0, 1];
    var m = t.match(/(\d{1,2})\s*-\s*(\d{1,2})\s*(months?|mths?|m\b|years?|yrs?|y\b)/);
    if (m) { var k = /^m/.test(m[3]) ? 1 : 12; return [parseInt(m[1], 10) * k, parseInt(m[2], 10) * k]; }
    m = t.match(/(\d{1,2})\s*(months?|years?)/);
    if (m) { var k2 = /^m/.test(m[2]) ? 1 : 12; return [parseInt(m[1], 10) * k2, (parseInt(m[1], 10) + 1) * k2]; }
    return null;
  }
  function ranges(it) { return (it.variants || []).filter(function (v) { return v.available; }).map(function (v) { return sizeRange(v.title); }).filter(Boolean); }
  // 'fit' (can be worn by the child, one size up allowed), 'smaller' (baby sizes only) or 'larger'.
  function fitFor(it, child) {
    if (!child) return 'fit';
    var rs = ranges(it);
    if (!rs.length) return 'fit';
    if (rs.some(function (r) { return r[0] <= child[1] + 6 && r[1] >= child[0]; })) return 'fit';
    return rs.every(function (r) { return r[1] < child[0]; }) ? 'smaller' : 'larger';
  }
  function shortTitle(t) { return String(t || '').replace(/^Personalised\s+/i, '').replace(/\s+for\s+(Kids|Girls|Boys|Toddlers?|Babies)\b.*$/i, ''); }
  // The design without the garment and word order: "Pumpkin Patch Rabbit T-Shirt", "... Sweatshirt" and a re-worded
  // duplicate listing ("Happy Birthday Blue Heart Mummy" / "Happy Birthday Mummy Blue Heart") give the same key.
  function designKey(t) {
    return shortTitle(t).toLowerCase().replace(GARMENT_RE, ' ').replace(/\b(kids?|toddlers?|baby|babies|girls?|boys?|for|and|with|name)\b/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ').trim().split(/\s+/).filter(Boolean).sort().join(' ');
  }
  function garmentOf(type, title) {
    var t = String(type || '').toLowerCase() + ' ' + String(title || '').toLowerCase();
    if (/sweatshirt|jumper|hoodie/.test(t)) return 'Sweatshirt';
    if (/bodysuit|vest/.test(t)) return 'Bodysuit';
    if (/pyjama|pjs/.test(t)) return 'Pyjamas';
    if (/t-?shirt|tee/.test(t)) return 'T-shirt';
    return '';
  }
  function context(data) {
    return { words: words(data.srcTitle), role: ROLE_RE.test(data.srcTitle || ''), age: ageOf(data.srcTitle), g: genderOf(data.srcTitle),
      key: designKey(data.srcTitle), dup: shortTitle(data.srcTitle).toLowerCase(), garment: garmentOf(data.srcType, data.srcTitle),
      size: sizeRange(data.srcSize), inCart: String(data.inCart || ''), text: ((data.srcTitle || '') + ' ' + (data.srcType || '')).toLowerCase() };
  }
  function ordinal(n) { var j = n % 10, k = n % 100; return n + (j === 1 && k !== 11 ? 'st' : j === 2 && k !== 12 ? 'nd' : j === 3 && k !== 13 ? 'rd' : 'th'); }
  // Why this design matches: same birthday age, else the first shared theme word, else "Matching design".
  function tagFor(c, r) {
    var age = ageOf(r.title);
    if (c.age && age === c.age) return ordinal(age) + ' birthday';
    var w = words(r.title);
    for (var k in c.words) {
      if (Object.prototype.hasOwnProperty.call(c.words, k) && w[k] && THEMES.indexOf(k) >= 0) return k.charAt(0).toUpperCase() + k.slice(1) + ' design';
    }
    return 'Matching design';
  }
  function themeScore(c, t) { var w = words(t), s = 0; for (var k in w) { if (Object.prototype.hasOwnProperty.call(w, k) && c.words[k]) s += c.words[k]; } return s; }
  // Shared checks for any suggested product: not shown, not in the basket, no wrong role, girl/boy and birthday age respected.
  function allowed(c, shown, r) {
    if (!r || !r.id || shown[r.id] || c.inCart.indexOf('|' + r.id + '|') >= 0) return false;
    if (!c.role && ROLE_RE.test(r.title || '')) return false;
    if (shortTitle(r.title).toLowerCase() === c.dup) return false; // a duplicate listing of the same design
    var g = genderOf(r.title);
    if (c.g && g && g !== c.g) return false;
    var age = ageOf(r.title);
    if (c.age && age && age !== c.age) return false; // a "1st birthday" design never follows a 4th birthday one
    return true;
  }
  function threshold() {
    var t = root && parseFloat(root.getAttribute('data-t1'));
    return (t > 0 ? t : 30) * 100;
  }
  function rootPath() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function wrapDrawer() {
    root = document.getElementById('aovxd-root');
    if (!root) return false;
    var items = root.querySelector('[data-aovxd-items]');
    if (!items) return false;
    if (!root.querySelector('.lili-dscroll')) {
      var wrap = document.createElement('div');
      wrap.className = 'lili-dscroll';
      items.parentNode.insertBefore(wrap, items);
      wrap.appendChild(items); // the drawer keeps its reference; only the parent changes
      block = document.createElement('section');
      block.className = 'lili-dset';
      block.setAttribute('aria-label', 'Picked for you');
      block.hidden = true;
      wrap.appendChild(block);
      // Footer: keep only subtotal + checkout sticky; the note and "View full basket" scroll with the items.
      var foot = root.querySelector('.aovxd-foot');
      var tailEl = document.createElement('div');
      tailEl.className = 'lili-dtail';
      wrap.appendChild(tailEl);
      ['.aovxd-note', '.aovxd-view'].forEach(function (sel) { var el = foot && foot.querySelector(sel); if (el) tailEl.appendChild(el); });
      // Friendly reminder notice (24 Sep): shown under checkout because basket reminder emails also go to non-subscribers.
      if (foot && !foot.querySelector('.lili-dremind')) { var rm = document.createElement('p'); rm.className = 'lili-dremind'; rm.textContent = 'Got distracted? We’ll send a friendly reminder with your basket. Unsubscribe anytime.'; foot.appendChild(rm); }
      root.classList.add('lili-dfoot-compact');
      new MutationObserver(schedule).observe(items, { childList: true });
      new MutationObserver(function () { if (root.classList.contains('open')) schedule(); }).observe(root, { attributes: true, attributeFilter: ['class'] });
    }
    block = root.querySelector('.lili-dset');
    try { mountDispatch(); } catch (e) {}
    return true;
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { try { paintDispatch(); } catch (e) {} loadSet(); }, 250); }
  function parseJson(html, sel) {
    var holder = document.createElement('div');
    holder.innerHTML = html || '';
    var s = holder.querySelector(sel);
    return s ? JSON.parse(s.textContent) : null;
  }
  function loadSet() {
    if (!block || busy) return;
    // Only while the basket is open and has something in it.
    if (!root.classList.contains('open')) return;
    if (root.querySelector('[data-aovxd-items] .aovxd-empty')) { block.hidden = true; lastKey = ''; return; }
    fetch(rootPath() + '?sections=lili-drawer-set', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var data = j && j['lili-drawer-set'] ? parseJson(j['lili-drawer-set'], '[data-lili-dset-json]') : null;
        if (!data) { block.hidden = true; return; }
        return enrich(data).then(render);
      }).catch(function () { block.hidden = true; });
  }
  // Candidate lists (related products, design-word search, event best sellers), kept for 30 minutes in this tab.
  function candidates(path, json) {
    if (cache[path]) return cache[path];
    var key = 'lili-dcand:' + path, hit = null;
    try { hit = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    if (hit && hit.t > Date.now() - 1800000 && hit.items) return (cache[path] = Promise.resolve(hit.items));
    cache[path] = fetch(rootPath() + path, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? (json ? r.json() : r.text()) : null; })
      .then(function (body) {
        var html = json ? (body && body['lili-drawer-similar']) : body;
        var d = parseJson(html, '[data-lili-dsim-json]');
        var items = (d && d.items) || [];
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
        return items;
      }).catch(function () { return []; });
    return cache[path];
  }
  function activeEvents(c) {
    var p = ukParts(new Date()), md = p.ymd.slice(5), y = p.ymd.slice(0, 4), now = [], soon = [];
    var today = Date.UTC(+y, +md.slice(0, 2) - 1, +md.slice(3));
    EVENTS.forEach(function (e) {
      var from = e.from, to = e.to, tag = e.tag;
      if (e.dates) { var d = e.dates[y]; if (!d) return; from = d[0]; to = d[1]; tag = e.tag + ' · ' + d[2]; }
      if (e.words.some(function (w) { return c.text.indexOf(w) >= 0; })) return; // the basket item is already for this event
      var ev = { handle: e.handle, tag: tag, to: to };
      if (md >= from && md <= to) now.push(ev);
      else {
        var start = Date.UTC(+y, +from.slice(0, 2) - 1, +from.slice(3));
        if (start < today && !e.dates) start = Date.UTC(+y + 1, +from.slice(0, 2) - 1, +from.slice(3)); // e.g. Valentine's seen from December
        if (start > today && start - today <= 30 * 86400000) soon.push(ev);
      }
    });
    now.sort(function (a, b) { return a.to < b.to ? -1 : 1; });
    return (now.length ? now : soon).slice(0, 2);
  }
  function enrich(data) {
    // Different designs only (Patryk, 24 Sep): no "Same design" pieces; map designs must fit the child.
    var c = context(data), shown = {};
    data.items = (data.items || []).filter(function (it) {
      if (!it || it.kind === 'same') return false;
      shown[it.id] = 1;
      if (it.kind === 'similar') return designKey(it.title) !== c.key && fitFor(it, sizeRange(it.srcSize || data.srcSize)) === 'fit';
      return true;
    });
    if (!data.srcId) return Promise.resolve(data);
    var ws = Object.keys(c.words).filter(function (w) { return c.words[w] > 1; }).slice(0, 4);
    var jobs = [candidates('recommendations/products?product_id=' + encodeURIComponent(data.srcId) + '&limit=10&intent=related&section_id=lili-drawer-similar', false)];
    jobs.push(ws.length ? candidates('search?q=' + encodeURIComponent(ws.join(' OR ')) + '&type=product&options%5Bprefix%5D=last&sections=lili-drawer-similar', true) : Promise.resolve([]));
    var evs = activeEvents(c);
    evs.forEach(function (e) { jobs.push(candidates('collections/' + e.handle + '?sort_by=best-selling&sections=lili-drawer-similar', true)); });
    return Promise.all(jobs).then(function (lists) {
      var count = function (k) { return data.items.filter(function (i) { return i.kind === k; }).length; };
      var take = function (r, kind, tag, name) { r.kind = kind; r.tag = tag; r.srcName = name; shown[r.id] = 1; data.items.push(r); };
      // A suggestion must be allowed, a different design from the basket item, and fit the child.
      var ok = function (r) { return allowed(c, shown, r) && designKey(r.title) !== c.key && fitFor(r, c.size) === 'fit'; };
      // 1. Upcoming events: the best-selling event piece that suits this child (theme, garment, size), name filled in.
      var per = evs.length === 1 ? 2 : 1;
      evs.forEach(function (e, k) {
        var list = lists[2 + k] || [], picked = [];
        list.map(function (r, idx) {
          if (!ok(r)) return null;
          return { r: r, s: themeScore(c, r.title) + (garmentOf('', r.title) === c.garment ? 1.5 : 0) + (1 - idx / list.length) };
        }).filter(Boolean).sort(function (a, b) { return b.s - a.s; }).forEach(function (x) {
          if (picked.length >= per) return;
          if (picked.length && garmentOf('', picked[0].title) === garmentOf('', x.r.title) && list.length > 4) return; // two different garments
          picked.push(x.r);
        });
        picked.forEach(function (r) { take(r, 'event', e.tag, data.srcName || ''); });
      });
      // 2. Smart set of different matching designs: shared theme words (same birthday age counts extra), one card per
      //    design, garments mixed (each repeat of a garment costs a little), best first.
      var keys = {};
      keys[c.key] = 1;
      data.items.forEach(function (i) { keys[designKey(i.title)] = 1; });
      var gcount = {};
      data.items.forEach(function (i) { if (i.kind === 'similar') { var g = garmentOf('', i.title); gcount[g] = (gcount[g] || 0) + 1; } });
      var cands = lists[0].concat(lists[1]).map(function (r, idx) {
        if (!ok(r)) return null;
        var s = themeScore(c, r.title);
        return s >= 2 ? { r: r, s: s + (c.age && ageOf(r.title) === c.age ? 1 : 0), i: idx, g: garmentOf('', r.title), k: designKey(r.title) } : null;
      }).filter(Boolean);
      while (count('similar') < MAX_SIMILAR) {
        var best = null;
        cands.forEach(function (x) {
          if (x.used || keys[x.k] || shown[x.r.id]) return;
          var v = x.s - 0.75 * (gcount[x.g] || 0) - x.i * 0.01;
          if (!best || v > best.v) best = { x: x, v: v };
        });
        if (!best) break;
        best.x.used = true; keys[best.x.k] = 1; gcount[best.x.g] = (gcount[best.x.g] || 0) + 1;
        take(best.x.r, 'similar', tagFor(c, best.x.r), data.srcName || '');
      }
      return data;
    });
  }
  function render(data) {
    var all = ((data && data.items) || []).filter(function (i) { return i && i.variants && i.variants.some(function (v) { return v.available; }); });
    var by = function (k) { return all.filter(function (i) { return i.kind === k; }); };
    // Order: two best matching designs, the event pieces, more matching designs, family pieces, "For a sibling" last.
    var sim = by('similar');
    var items = sim.slice(0, 2).concat(by('event'), sim.slice(2), by('family'), by('sibling'));
    while (items.length > MAX_CARDS) {
      var cut = -1;
      for (var q = items.length - 1; q >= 0; q--) { if (items[q].kind === 'similar') { cut = q; break; } }
      if (cut < 0) break;
      items.splice(cut, 1);
    }
    items = items.slice(0, MAX_CARDS);
    if (!items.length) { block.hidden = true; block.innerHTML = ''; lastKey = ''; return; }
    data.items = items;
    var key = data.total + ':' + items.map(function (i) { return i.kind + i.id; }).join(',');
    if (key === lastKey && !block.hidden) return;
    lastKey = key;
    var name = data.srcName || '';
    var head = data.names > 1 ? 'Picked for them' : name ? 'Picked for ' + esc(name) : 'Picked for you';
    var need = threshold() - data.total;
    var h = '<div class="lili-dset__head"><h3 class="lili-dset__title">' + head + '</h3>' +
      (items.length > 2 ? '<span class="lili-dset__swipe" aria-hidden="true">Swipe for more →</span>' : '') +
      '</div><div class="lili-dset__row" role="list">';
    items.forEach(function (it, idx) {
      var after = need - it.price;
      var hint = need <= 0 ? '' : (after <= 0 ? 'Unlocks free delivery' : money(after) + ' from free delivery');
      h += '<div class="lili-dset__card lili-dset__card--' + esc(it.kind) + '" role="listitem">' +
        (it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(shortTitle(it.title)) + '" width="136" height="136" loading="lazy">' : '') +
        '<div class="lili-dset__meta"><small>' + esc(it.tag) + '</small><strong>' + esc(it.short) + '</strong><span>' + (it.priceVaries ? 'From ' : '') + money(it.price) + '</span>' +
        (hint ? '<em>' + hint + '</em>' : '') + '</div>' +
        '<button type="button" class="lili-dset__open" data-open="' + idx + '" aria-expanded="false">Add +</button></div>';
    });
    h += '</div><div class="lili-dset__panel" hidden></div>';
    block.innerHTML = h;
    block.hidden = false;
    block._data = data;
  }
  function forSibling(it) { return it.kind === 'sibling' || it.kind === 'family'; }
  function openPanel(idx) {
    var data = block._data, it = data && data.items[idx];
    if (!it) return;
    var panel = block.querySelector('.lili-dset__panel');
    block.querySelectorAll('[data-open]').forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('data-open') === String(idx))); });
    var sib = forSibling(it);
    // Same child: preselect the size that matches the basket item.
    var child = sib ? null : sizeRange(it.srcSize || data.srcSize), pre = '';
    if (child) {
      it.variants.some(function (v) { var r = v.available && sizeRange(v.title); if (r && r[0] === child[0] && r[1] === child[1]) { pre = String(v.id); return true; } return false; });
    }
    var opts = '<option value=""' + (pre ? '' : ' selected') + ' disabled>Choose size</option>';
    it.variants.forEach(function (v) {
      opts += '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + (String(v.id) === pre ? ' selected' : '') + '>' + esc(v.title) + (v.available ? '' : ' (sold out)') + (it.priceVaries ? ' · ' + money(v.price) : '') + '</option>';
    });
    var uid = 'lili-dset-' + idx;
    var title = it.kind === 'sibling' ? it.short + ' for a sibling' : it.kind === 'family' ? it.tag + ': ' + it.short
      : it.kind === 'event' ? it.tag + ': ' + shortTitle(it.title) : shortTitle(it.title);
    var html = '<p class="lili-dset__ptitle">' + esc(title) + '</p>' +
      '<label for="' + uid + '-size">Size</label><select id="' + uid + '-size" data-size>' + opts + '</select>';
    if (it.perso) {
      html += '<label for="' + uid + '-name">' + esc(it.label || 'Name to print') + '</label>' +
        '<input id="' + uid + '-name" type="text" maxlength="22" autocomplete="off" data-name value="' + esc(sib ? '' : (it.srcName || '')) + '" placeholder="' + (sib ? 'Their name' : 'e.g. Sophie') + '">';
      if (it.key2) {
        html += '<label for="' + uid + '-name2">' + esc(it.label2 || it.key2) + '</label>' +
          '<input id="' + uid + '-name2" type="text" maxlength="22" autocomplete="off" data-name2>';
      }
      html += '<small class="lili-dset__help">' + (sib ? 'Same design with their own name. Printed exactly as typed.' : 'Printed exactly as typed. Change it if this one is for a brother or sister.') + '</small>';
    }
    html += '<div class="lili-dset__err" role="alert"></div>' +
      '<button type="button" class="lili-dset__add" data-add="' + idx + '">Add to basket · ' + money(it.price) + '</button>' +
      '<a class="lili-dset__link" href="' + esc(it.url) + '">View full details</a>';
    panel.innerHTML = html;
    panel.hidden = false;
    var card = block.querySelectorAll('.lili-dset__card')[idx];
    if (card && card.scrollIntoView) { try { card.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
    var sel = panel.querySelector('[data-size]');
    if (sel && !pre) sel.focus({ preventScroll: true }); // size already chosen: no focus, so no phone keyboard pops up
    try { panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
  }
  function add(idx) {
    var data = block._data, it = data && data.items[idx];
    var panel = block.querySelector('.lili-dset__panel');
    if (!it || !panel) return;
    var err = panel.querySelector('.lili-dset__err');
    var sel = panel.querySelector('[data-size]');
    var nameEl = panel.querySelector('[data-name]');
    var name2El = panel.querySelector('[data-name2]');
    var vid = sel && sel.value;
    var name = nameEl ? nameEl.value.trim() : '';
    var name2 = name2El ? name2El.value.trim() : '';
    if (!vid) { err.textContent = 'Please choose a size.'; sel.focus(); return; }
    if (it.perso && !name) { err.textContent = forSibling(it) ? 'Please type their name.' : 'Please type the name to print.'; nameEl.focus(); return; }
    var props = { '_aovx': 'drawer-set', '_aovx_kind': it.kind || 'similar' };
    if (it.perso) props[it.key || 'Name'] = name;
    if (it.perso && it.key2 && name2) props[it.key2] = name2;
    var btn = panel.querySelector('[data-add]');
    btn.disabled = true; btn.textContent = 'Adding…'; busy = true;
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1, properties: props }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j && (j.description || j.message) || 'add failed'); return j; }); })
      .then(function () { busy = false; lastKey = ''; panel.hidden = true; if (!window.aovxdOpen && window.aovxdRefresh) window.aovxdRefresh(); })
      .catch(function (e) { busy = false; btn.disabled = false; btn.textContent = 'Add to basket · ' + money(it.price); err.textContent = 'Sorry, that did not work: ' + e.message; });
  }
  function bindDrawer() {
    if (!wrapDrawer()) return;
    block.addEventListener('click', function (e) {
      var o = e.target.closest('[data-open]');
      if (o) { openPanel(parseInt(o.getAttribute('data-open'), 10)); return; }
      var a = e.target.closest('[data-add]');
      if (a) add(parseInt(a.getAttribute('data-add'), 10));
    });
    block.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-name],[data-name2]')) { e.preventDefault(); var b = block.querySelector('[data-add]'); if (b) b.click(); }
    });
    schedule();
  }

  /* ---------- Product reviews: shop reviews when a product has none ---------- */
  function reviewsFallback() {
    if (!document.documentElement.classList.contains('lili-pdp')) return;
    var shop = document.querySelector('[id$="__lili_shop_reviews"]');
    var tries = 0;
    (function check() {
      var w = document.querySelector('.jdgm-rev-widg[data-number-of-reviews]');
      if (!w) { if (++tries < 40) return setTimeout(check, 250); return; }
      var count = parseInt(w.getAttribute('data-number-of-reviews'), 10) || 0;
      var host = w.closest('.shopify-section') || w.parentNode;
      if (count > 0 || !shop) return;
      if (host) host.classList.add('lili-reviews-empty');
      shop.classList.add('lili-shop-reviews--on');
      if (host && host.parentNode && shop.nextElementSibling !== host) host.parentNode.insertBefore(shop, host);
    })();
  }

  function boot() {
    try { mountDispatch(); } catch (e) {}
    try { bindDrawer(); } catch (e) {}
    try { reviewsFallback(); } catch (e) {}
    setInterval(function () { try { mountDispatch(); } catch (e) {} }, 30000);
    // The drawer and product modules are built by other scripts; mount again once they exist.
    [600, 1500, 3000].forEach(function (ms) { setTimeout(function () { try { mountDispatch(); if (!block) bindDrawer(); } catch (e) {} }, ms); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
